module.exports = __webpack_public_path__ + "static/bael-44c0b88c66601fdd9029ba456a155e2a.png";